<template>
    <div class="other-files">
        <div
            class="single-file"
            v-for="(file, index) in otherFiles"
            :key="`${file.file.name}-${index}`">
            <div class="file-name">
                <div class="icon">
                    <i class="fa fa-file-alt"></i>
                </div>
                <div class="file-description">{{ file.file.name }}</div>
                <b-button
                    class="clickable"
                    variant="link"
                    @click="previewFile(file.file)">
                </b-button>
            </div>

            <b-button
                class="btn-download btn-file-download"
                variant="link"
                :href="file.file.public_path"
                download
                target="_blank">
            </b-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-profile-card-file-component',
        props: ['card', 'otherFiles'],
        data() {
            return {};
        },
        methods: {
            previewFile(file) {
                this.$root.$refs.filePreview.show(file);
            },
        },
    };
</script>

<style scoped lang="scss">
    .other-files {
        .single-file {
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            column-gap: map-get($grid-gutter-spacing, 'forty-two');
            font-size: 1.3125rem;
            line-height: 1;
            padding: map-get($grid-gutter-spacing, 'ten') 0;

            .icon {
                align-self: center;
                padding: map-get($grid-gutter-spacing, 'eight');
                border-radius: $border-radius-content;
                color: $primary;
            }

            .file-name {
                position: relative;
                display: flex;
                align-items: center;
                font-size: $base-font-size;
                white-space: normal;
                word-break: break-word;

                .file-description {
                    font-size: $default-font-size;
                }

                &:hover {
                    .icon,
                    .file-description {
                        color: var(--primaryLightest);
                    }
                }
            }

            &:not(:last-child) {
                padding-bottom: map-get($grid-gutter-spacing, 'ten');
                border-bottom: 3px dotted $border-color;
            }
        }
    }
</style>
